<template>
    <div id="tryout-group">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'OSS Configs',
                    to: { path: '/landing-packages' },
                    exact: true,
                },
                {
                    text: 'Paket Landing Page',
                    to: { path: '/landing-packages' },
                    exact: true,
                },
                { text: datas.category_name },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">{{ datas.category_name }}</h3>

        <v-card>
            <v-card-title class="text-subtitle-1 font-weight-bold">
                Pilih Kelas
            </v-card-title>
            <v-card-text class="py-0">
                <v-radio-group
                    row
                    v-model="selectedRow"
                    active-class="act-radio-btn"
                    class="pt-0 mt-0"
                >
                    <v-row>
                        <v-col
                            cols="3"
                            class="pa-3"
                            v-for="(card, index) in liveClasses"
                            v-bind:key="index"
                        >
                            <v-card flat outlined>
                                <v-list
                                    style="min-height: none !important"
                                    two-line
                                >
                                    <v-list-item class="px-4">
                                        <template>
                                            <v-list-item-content
                                                class="pa-0 ma-0"
                                            >
                                                <v-list-item-title
                                                    class="text-subtitle-1 font-weight-bold black--text"
                                                    style="
                                                        word-break: break-word !important;
                                                    "
                                                >
                                                    Kelas {{ card.kelas }}
                                                </v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-radio
                                                    :value="card"
                                                    class="jenjang-selection pa-0 ma-0"
                                                ></v-radio>
                                            </v-list-item-action>
                                        </template>
                                    </v-list-item>
                                </v-list>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-radio-group>
            </v-card-text>
        </v-card>

        <v-card v-if="selectedRow != null" class="my-4">
            <v-card-title> Daftar {{ datas.category_name }} </v-card-title>
            <v-divider />

            <v-list three-line style="min-height: none !important" class="pa-0">
                <template>
                    <v-list-item
                        v-for="card in selectedRow.pakets"
                        v-bind:key="card.id_paket"
                        @click="
                            selectedPackage = card;
                            editPackage();
                        "
                    >
                        <v-list-item-content
                            class="pt-4 pb-6 ml-2"
                            style="max-width: 45px"
                        >
                            <v-list-item-subtitle>
                                <span
                                    class="roboto-text darkblue--text"
                                    :class="
                                        $vuetify.breakpoint.smAndDown
                                            ? 'font-weight-600'
                                            : 'font-weight-700'
                                    "
                                    :style="
                                        $vuetify.breakpoint.smAndDown
                                            ? 'font-size:15px'
                                            : ''
                                    "
                                >
                                    ID
                                </span>
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                                {{ card.id }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-content class="pt-4 pb-6">
                            <v-list-item-subtitle>
                                <span
                                    class="roboto-text darkblue--text"
                                    :class="
                                        $vuetify.breakpoint.smAndDown
                                            ? 'font-weight-600'
                                            : 'font-weight-700'
                                    "
                                    :style="
                                        $vuetify.breakpoint.smAndDown
                                            ? 'font-size:15px'
                                            : ''
                                    "
                                >
                                    Nama
                                </span>
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                                {{ card.deskripsi }}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action class="d-flex align-self-center">
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                </template>
            </v-list>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import AppSpinner from "@/components/plugins/Spinner";
import DataTable from "@/components/plugins/DataTable";

export default {
    name: "LandingPackageClassList",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            liveClasses: [],
            datas: null,
            selectedRow: null,
            isLoading: false,
            search: null,
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            headers: ["ID", "Kelas"],
            headersKey: ["id", "kelas"],
            selectedPackage: null,
        };
    },

    mounted: function () {
        this.fetchDatas();
    },

    watch: {},

    methods: {
        async fetchDatas() {
            var context = this;
            this.datas = [];
            try {
                const resp = this.$store.state.landingpackages.data || [];
                this.datas = resp.find((ed) => {
                    return ed.id == this.$route.params.id;
                });

                this.datas.list_data.forEach(function (group) {
                    var row = {
                        id: group.id,
                        kelas: group.kelas,
                        pakets: group.pakets,
                    };

                    context.liveClasses.push(row);

                    context.isLoading = false;
                });
                context.isLoading = false;
            } catch (error) {
                this.$router.push("/landing-packages");
            }
        },

        editliveClass: function () {
            var context = this;
            var groupId = this.selectedRow.id;
            context.$router.push({
                path:
                    "/landing-packages/" +
                    this.$route.params.id +
                    "/" +
                    groupId,
                query: { idkelas: this.selectedRow.id_kelas },
            });
        },

        editPackage: function () {
            var context = this;
            context.$store.commit("package_onedit", this.selectedPackage);
            const infos = {
                categoryId: this.$route.params.id,
                kelasPaket: this.selectedRow.kelas,
                idKelas: this.selectedRow.id,
                detailId: this.selectedPackage.id,
                category: this.datas,
            };
            context.$store.commit("package_info_update", infos);

            context.$router.push({ name: "LandingPackageForm" });
        },

        deleteliveClass: function (tryout) {
            var context = this;
            var groupId = tryout.id;

            var confirmed = window.confirm(
                "Apakah anda yakin akan menghapus Live Class ini?",
            );

            if (confirmed) {
                LiveClassService.deleteLiveClass(groupId, function (result) {
                    if (result.success) {
                        alert("Berhasil menghapus data!");
                        context.fetchData();
                    }
                    context.isLoading = false;
                });
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// ListClasses.vue?3e9e7b54